---
fr:
  page_hits:
    admin:
      filters:
        all_time: Tout le temps
        custom: Personnalisé
        matching_referrer_page: Page de référence correspondante
        user_logged_in: Utilisateur connecté
        week_ago: Il y a 1 semaine
      table:
        action: Action
        controller: Contrôleur
        hit_count: Nombre de visites
        percentage: Pourcentage
      tabs:
        page_hits: Visites de page
        users: Utilisateurs
